import { render, staticRenderFns } from "./TypeSearch.vue?vue&type=template&id=6e23e9ac"
import script from "./TypeSearch.vue?vue&type=script&lang=js"
export * from "./TypeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports